import React from "react";
import HeadingSample from "../components/utility/headingSample";
import { motion } from "framer-motion";
import StakingVsRwaDividends from "../components/investor_Portal/StakingVsRwaDividends";
import PortfolioHealthBreakdown from "../components/investor_Portal/PortfolioHealthBreakdown";
import MiningReservesExpansion from "../components/investor_Portal/MiningReservesExpansion";
import UnstakedTokensChart from "../components/investor_Portal/UnstakedTokensChart";
import TokenPriceFluctuationsChart from "../components/investor_Portal/TokenPriceFluctuationsChart";
import TokenHoldingsBreakdownChart from "../components/investor_Portal/TokenHoldingsBreakdownChart";

const sec1Subtitle = "Get review our strategy and performance";
const sec1Title = ["Investor Portal", "#F8D835"];


const Investor_Portal: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center gap-6 bg-white box-border overflow-hidden">
      <motion.div
        id="invest_Portal_Home"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="h-[500px] sm:h-[700px] w-full bg-[url('../public/investor_Portal/section1.svg')] bg-black/30 bg-blend-overlay bg-cover bg-center"
      >
        <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
      </motion.div>
      {/* <div className="w-full max-w-7xl p-6 grid gap-6 grid-cols-1 md:grid-cols-2">
        <div id = "token_status" className="col-span-full grid grid-cols-1 sm:grid-cols-4 gap-4">
          {["Total Utility Tokens Held", "Total RWA Tokens Held", "Staking Rewards", "Dividend Earnings"].map((label, idx) => (
            <div key={idx} className="bg-white p-4 rounded-xl shadow border-l-4 border-yellow-400">
              <p className="text-gray-600 text-sm">{label}</p>
              <div className="flex flex-row justify-start items-center gap-4">
                <h2 className="text-2xl font-bold text-yellow-500">672</h2>
                <img src="/investor_Portal/Vector.svg" alt="vector_graphic" />
              </div>
            </div>
          ))}
        </div>

        <TokenHoldingsBreakdownChart />
        <StakingVsRwaDividends />

        <TokenPriceFluctuationsChart />

        <PortfolioHealthBreakdown />

        <UnstakedTokensChart />
        <MiningReservesExpansion />
      </div> */}
      <div className="w-full h-screen flex flex-col justify-center items-center text-xl sm:text-2xl lg:text-5xl">
        Under Construction 
      </div>
    </div>
  );
};

export default Investor_Portal;
